import React from "react";

import StyleValuesSlice from "../../components/slices/styleValues/StyleValuesSlice";

const StyleValues = ({ slice }) => {
  return <StyleValuesSlice slice={slice} />;
};

export default StyleValues;
